var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * A class that represents the configuration of working hours related options of scheduler.
 */

var WorkHours =
/** @class */
function (_super) {
  __extends(WorkHours, _super);

  function WorkHours() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Property(true)], WorkHours.prototype, "highlight", void 0);

  __decorate([Property('09:00')], WorkHours.prototype, "start", void 0);

  __decorate([Property('18:00')], WorkHours.prototype, "end", void 0);

  return WorkHours;
}(ChildProperty);

export { WorkHours };